import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, InternalCandidacyComment } from "@/types";

export function useGetInternalCandidacyComments({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "internal-candidacy-comments",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/internal-candidacy-comments`;
      const res = await guacHttpClient.get<
        InternalCandidacyComment[],
        HttpResponse<InternalCandidacyComment[]>
      >(path);
      return res.data;
    },
  });
}
